import { useEffect, useState } from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';
import useBooking from "../hooks/useBooking";

const BookingTypesDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled} = props;

    const theme = useTheme();

    const {isFetchingBookingTypes, bookingTypes, getBookingTypes} = useBooking();
    const [bookingsTypesData, setBookingTypesData] = useState([]);
    const [inputValue, setInputValue] = useState("");
    

    useEffect(() => {
        getBookingTypes();
    }, [])

    useEffect(() => {
        if (bookingTypes?.length > 0) {
            setBookingTypesData(bookingTypes);
        }
    }, [bookingTypes])


    const handleChange = (value) => {
        onChange(value);
    }

    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={bookingsTypesData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={value}
                loading={isFetchingBookingTypes}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Type not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search booking type"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isFetchingBookingTypes ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default BookingTypesDropdownComponent